import { render } from "./ViewAllRestaurants.vue?vue&type=template&id=3e6e9e8a&scoped=true"
import script from "./ViewAllRestaurants.vue?vue&type=script&lang=js"
export * from "./ViewAllRestaurants.vue?vue&type=script&lang=js"

import "./ViewAllRestaurants.vue?vue&type=style&index=0&id=3e6e9e8a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6e9e8a"]])

export default __exports__